module.exports = __webpack_public_path__ + "img/hr-green-pita-mini-00.f2decf10.png";